import * as React from "react";
import { Dialog } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { StaticImage } from 'gatsby-plugin-image';
import { Link } from "gatsby";
import Navigation from "../utilities/navigation";
import Socials from "../utilities/socials";

const NavBar = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
    /* const mobileMenuOpenHandler = React.useCallback((value: boolean) => {
        setMobileMenuOpen(value);
    }, [setMobileMenuOpen]); */

    const socialArray = Object.keys(Socials).map(socialName => ({
        name: socialName,
        ...Socials[socialName],
    }));

    return (
        <nav className="nav-bar-bg">
            <div className="mx-auto max-w-7xl nav-bar-bg">
                <nav className="flex flex-row mx-8 sm:mx-10 h-20 items-center justify-between" aria-label="Global">
                    <div className="flex w-full content-center items-center justify-center lg:content-start lg:items-start lg:justify-start lg:max-w-fit lg:min-w-0 lg:flex-initial">
                        <a href="/" className="-m-1.5 p-1.5">
                            <span className="sr-only">Split Counter App</span>
                            <StaticImage className="w-16" src="../assets/images/logo.png" alt="Slip counter app logo" />
                        </a>
                    </div>
                    <div className="absolute pt-7 pr-9 top-0 right-0 z-10 content-end items-end justify-end lg:hidden">
                        <button
                            type="button"
                            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white"
                            onClick={() => setMobileMenuOpen(true)}
                        >
                            <span className="sr-only">Open main menu</span>
                            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                        </button>
                    </div>
                    <div className="hidden sm:hidden sm:flex-auto sm:gap-x-12 lg:flex ml-16 sm:ml-8 lg:min-w-0 lg:flex-auto lg:justify-start lg:gap-x-8">
                        {Navigation.map((item) => (
                            <Link key={item.name} to={item.href} className='font-semibold text-lg text-white hover:text-red-500'>
                                {item.name}
                            </Link>
                        ))}
                    </div>
                    <div className="hidden sm:hidden sm:flex-auto sm:gap-x-12 lg:flex ml-16 sm:ml-8 lg:min-w-0 lg:flex-auto lg:justify-end lg:gap-x-12">
                        {socialArray.map((social) => (
                            <a key={social.name} href={social.link} rel={social.name === 'Mastodon' ? "me" : ""} target="_blank" className="font-semibold text-sm text-white hover:text-red-500">
                                {social.icon}
                            </a>
                        ))}
                    </div>
                </nav>
                <Dialog as="div" open={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)}>
                    <Dialog.Panel className="fixed pt-2 inset-0 z-10 overflow-y-auto nav-bar-bg px-6 lg:hidden">
                        <div className="flex mx-2 items-center"> {/* flex mx-2 items-center justify-between */}
                            <div className="flex w-full content-center items-center justify-center lg:min-w-0 lg:flex-initial">
                                <a href="#" className="-m-1.5 p-1.5">
                                    <span className="sr-only">Split Counter App</span>
                                    <StaticImage className="w-16" src="../assets/images/logo.png" alt="Slip counter app logo" />
                                </a>
                            </div>
                            <div className="absolute pt-7 pr-9 top-0 right-0 z-10 content-end items-end justify-end">
                                <button
                                    type="button"
                                    className="inline-flex items-center justify-center rounded-md text-white"
                                    onClick={() => setMobileMenuOpen(false)}
                                >
                                    <span className="sr-only">Close menu</span>
                                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                                </button>
                            </div>
                        </div>
                        <div className="mt-16 flow-root">
                            <div className="-my-6 divide-y divide-red-500/10">
                                <div className="flex flex-col items-center space-y-2 py-6 mx-10">
                                    {Navigation.map((item) => (
                                        <Link key={item.name} to={item.href} className='font-semibold text-lg text-white hover:text-red-500'>
                                            {item.name}
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-row gap-x-14 sm:gap-x-16 sm:mt-5 md:gap-x-20 items-center justify-center space-y-2 py-6 mx-10">
                            {socialArray.map((social) => (
                                <a key={social.name} href={social.link} rel={social.name === 'Mastodon' ? "me" : ""} className="font-semibold text-sm text-white hover:text-red-500">
                                    {social.icon}
                                </a>
                            ))}
                        </div>
                    </Dialog.Panel>
                </Dialog>
            </div>
        </nav>
    );
};

export default NavBar;